export default __webpack_public_path__ + "static/modal3-a6fc90b2bf803f4459786fac5a5442ec.png";